//let template = require('es6-template-string');
import templateEngine from 'es6-template-string'
import {
    adElementTemplate,
    adLineTemplate,
    articleTemplate,
    base64_tvl_logo, base64_tvl_volleyball_logo,
    footerTemplate,
    lineTemplate,
    mailTemplate
} from "./htmlTemplates";
import {linksLeichtathletik, linksVolleyball} from "./adLinks";

abstract class GenericHTMLGenerator{
    abstract getLogo(): string
    abstract getAdLinks(): string[]
    abstract getLinkToViewInBrowser(): string
    abstract getClubName(): string
    abstract getInstaLink(): string
    abstract getFacebookLink(): string

    generateHTML(mailText: string, articles: Article[]): string{
        const articleHTML = articles.map((article, index) => this.getHTMLOfArticle(article, index))
        const articlesLinesHTML = this.getHTMLofArticleLines(articleHTML)
        const footerHTML = this.getHTMLOfFooter(this.getAdLinks(), this.getClubName())
        const newsletter = this.getHTMLOfMail(articlesLinesHTML, footerHTML, "<span>"+ mailText + "</span>")
        return newsletter

    }

    private getHTMLOfArticle(article: Article, position: number): string{
        const pos = position % 2 === 0 ? 'left' : 'right'
        const template = templateEngine.compile(articleTemplate)

        return template({
            position: pos,
            article_title: article.title,
            article_path: article.link,
            article_picture: article.picturePath,
            article_text:article.detail
        })
    }

    private getHTMLofArticleLines(articleHTMLs: string[], html: string=""): string{
        if(articleHTMLs.length === 0){
            return html;
        }
        if(articleHTMLs.length === 1){
            const newLine = this.addArticlesToLine(articleHTMLs)
            return html + newLine
        }

        const first: string =  articleHTMLs.shift() ?? ""
        const second: string  = articleHTMLs.shift() ?? ""
        const newLine = this.addArticlesToLine([first, second])
        return this.getHTMLofArticleLines(articleHTMLs, html + newLine)
    }

    private addArticlesToLine(articles: string[]){
        const template = templateEngine.compile(lineTemplate)
        return template({articles: articles.join()})
    }

    private getHTMLOfFooter(adLinks: string[], clubName: string){
        const template = templateEngine.compile(footerTemplate)
        return template({
            ad_block: this.getHTMLOfAdBlock(adLinks),
            copyright: `${clubName}, ${new Date().getFullYear()}`,
            insta_link: this.getInstaLink(),
            facebook_link: this.getFacebookLink()
        })
    }

    /**
     * We only allow max 5 Ads per line. If we have more Ads, we use more lines.
     * Each Ad is represented as ad_element-Template
     * Each Line is represented as ad_line-Template
     * @param adLinks
     * @private
     */
    private getHTMLOfAdBlock(adLinks: string[]): string{
        const MAX_ELEMENTS_PER_LINE = 5
        let elementsPerLine = MAX_ELEMENTS_PER_LINE
        if(adLinks.length > 5){
            const numberLines = Math.ceil(adLinks.length / MAX_ELEMENTS_PER_LINE )
            elementsPerLine = Math.ceil(adLinks.length/numberLines)
        }
        const widthPercent: string =  Math.floor(100 / elementsPerLine).toString()

        let adBlock = ""
        let elementsInLine: string[] = []

        const compileElementsToALine = (elements: string[]): string => {
            const completeLine =  elements.join("\n")
            const lineTemplate = templateEngine.compile(adLineTemplate)
            return lineTemplate({ad_elements: completeLine})
        }

        for (const adLink of adLinks) {
            const elementTemplate = templateEngine.compile(adElementTemplate)
            const element = elementTemplate({
                width_percent: widthPercent,
                ad: adLink
            })
            elementsInLine.push(element)

            if(elementsInLine.length === elementsPerLine){
                //max number of elements in Line is reached. We flush the elements into a <tr></tr> Element
                adBlock += compileElementsToALine(elementsInLine) + "\n"
                elementsInLine = []
            }
        }

        //since the lines might not be fully filled, we have still un-flushed elements in the list
        if(elementsInLine.length > 0){
            adBlock += compileElementsToALine(elementsInLine)
        }

        return adBlock
    }

    private getHTMLOfMail(articlesAsLinesHTML: string,  footerHTML: string, text: string,): string{
        const template = templateEngine.compile(mailTemplate)
        return template({
            footer: footerHTML,
            articles: articlesAsLinesHTML,
            text: text,
            tvl_logo: this.getLogo(),
            linkToViewInBrowser: this.getLinkToViewInBrowser()
        })
    }
}

class LeichtathletikHTMLGenerator extends GenericHTMLGenerator{
    getLinkToViewInBrowser(): string {
        return "https://leichtathletik.tvlbern.ch/news"
    }
    getLogo(): string {
        return base64_tvl_logo
    }

    getAdLinks(): string[] {
        return linksLeichtathletik
    }

    getClubName(): string{
        return "TVL Leichtathletik"
    }

    getInstaLink(): string {
        return "https://www.instagram.com/tvl.leichtathletik/"
    }

    getFacebookLink(): string {
        return "https://www.facebook.com/tvlleichtathletik/";
    }
}

class VolleyballHTMLGenerator extends GenericHTMLGenerator{
    getLinkToViewInBrowser(): string {
        return "https://volleyball.tvlbern.ch/news"
    }
    getLogo(): string {
        return base64_tvl_volleyball_logo
    }

    getAdLinks(): string[] {
        return linksVolleyball
    }
    getClubName(): string{
        return "TVL Volleyball"
    }

    getInstaLink(): string {
        return "https://www.instagram.com/tvl_volleyball/";
    }

    getFacebookLink(): string {
        return "https://www.facebook.com/profile.php?id=100054874414698/";
    }

}

const sourceTypeMap: {[key: string]: any} = {
    leichtathletik: LeichtathletikHTMLGenerator,
    volleyball: VolleyballHTMLGenerator
}

function generateHTML(mailText: string, articles: Article[], sourceType?: string){
    let generator = undefined
    if(sourceType){
        generator = sourceTypeMap[sourceType]
    }
    if(!generator){
        // set fallback
        generator = LeichtathletikHTMLGenerator
    }

    return new generator().generateHTML(mailText, articles)
}


export {
    generateHTML
}
